import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import GeneralWorkPermitHealthDeclarationTextTab from "./GeneralWorkHealthDeclaration";
import HotWorkPermitHealthDeclarationTextTab from "./HotWorkHealthDeclaration";
import WorkAtHeightPermitHealthDeclarationTextTab from "./WorkAtHeightHealthDeclaration";
import ExcavationPermitHealthDeclarationTextTab from "./ExcavationHealthDeclaration";
import LiftingPermitHealthDeclarationTextTab from "./LiftingHealthDeclaration";
import PilingPermitHealthDeclarationTextTab from "./PilingHealthDeclaration";
import PipeJackingPermitHealthDeclarationTextTab from "./PipeJackingHealthDeclaration";
import ConfinedSpaceHealthDeclarationTextTab from "./ConfinedSpaceHealthDeclaration";
import ToolBoxMeetingHealthDeclarationTextTab from "./ToolBoxMeetingHealthDeclaration";

const HealthDeclarationTab = () => {
  const [verticalTab, setVerticalTab] = useState(
    "GeneralWorkHealthDeclarationPermit"
  );

  const toggleVertical = (tab: any) => {
    if (verticalTab !== tab) {
      setVerticalTab(tab);
    }
  };

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row>
            <Col md={3}>
              <Nav pills className="flex-column" id="v-pills-tab">
                {/* Default "ALL" Tab */}

                {/* Dynamically Render Team Tabs */}

                <NavItem key={1}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalTab === "HotWorkHealthDeclarationPermit",
                    })}
                    onClick={() =>
                      toggleVertical("HotWorkHealthDeclarationPermit")
                    }
                    id={`v-pills-${"HotWorkHealthDeclarationPermit".toLowerCase()}-tab`}
                  >
                    Hot Work Permit
                  </NavLink>
                </NavItem>

                <NavItem key={2}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active:
                        verticalTab === "GeneralWorkHealthDeclarationPermit",
                    })}
                    onClick={() =>
                      toggleVertical("GeneralWorkHealthDeclarationPermit")
                    }
                    id={`v-pills-${"GeneralWorkHealthDeclarationPermit".toLowerCase()}-tab`}
                  >
                    General Work Permit
                  </NavLink>
                </NavItem>

                <NavItem key={3}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active:
                        verticalTab === "WorkAtHeightHealthDeclarationPermit",
                    })}
                    onClick={() =>
                      toggleVertical("WorkAtHeightHealthDeclarationPermit")
                    }
                    id={`v-pills-${"WorkAtHeightHealthDeclarationPermit".toLowerCase()}-tab`}
                  >
                    Work At Height Permit
                  </NavLink>
                </NavItem>

                <NavItem key={4}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active:
                        verticalTab === "ConfinedSpacePermitHealthDeclaration",
                    })}
                    onClick={() =>
                      toggleVertical("ConfinedSpacePermitHealthDeclaration")
                    }
                    id={`v-pills-${"ConfinedSpacePermitHealthDeclaration".toLowerCase()}-tab`}
                  >
                    Confined Space Permit
                  </NavLink>
                </NavItem>

                <NavItem key={5}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalTab === "LiftingPermitHealthDeclaration",
                    })}
                    onClick={() =>
                      toggleVertical("LiftingPermitHealthDeclaration")
                    }
                    id={`v-pills-${"LiftingPermitHealthDeclaration".toLowerCase()}-tab`}
                  >
                    Lifting Permit
                  </NavLink>
                </NavItem>
                <NavItem key={6}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active:
                        verticalTab === "ExcavationHealthDeclarationPermit",
                    })}
                    onClick={() =>
                      toggleVertical("ExcavationHealthDeclarationPermit")
                    }
                    id={`v-pills-${"ExcavationHealthDeclarationPermit".toLowerCase()}-tab`}
                  >
                    Excavation Permit
                  </NavLink>
                </NavItem>
                <NavItem key={7}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active:
                        verticalTab === "PipeJackingHealthDeclarationPermit",
                    })}
                    onClick={() =>
                      toggleVertical("PipeJackingHealthDeclarationPermit")
                    }
                    id={`v-pills-${"PipeJackingHealthDeclarationPermit".toLowerCase()}-tab`}
                  >
                    PipeJacking Permit
                  </NavLink>
                </NavItem>
                <NavItem key={8}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalTab === "PilingHealthDeclarationPermit",
                    })}
                    onClick={() =>
                      toggleVertical("PilingHealthDeclarationPermit")
                    }
                    id={`v-pills-${"PilingHealthDeclarationPermit".toLowerCase()}-tab`}
                  >
                    Piling Permit
                  </NavLink>
                </NavItem>
                <NavItem key={9}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalTab === "ToolBoxMeetingHealthDeclaration",
                    })}
                    onClick={() =>
                      toggleVertical("ToolBoxMeetingHealthDeclaration")
                    }
                    id={`v-pills-${"ToolBoxMeetingHealthDeclaration".toLowerCase()}-tab`}
                  >
                    ToolBox Meeting
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>

            <Col md={9}>
              <TabContent
                activeTab={verticalTab}
                className="text-muted mt-4 mt-md-0"
                id="v-pills-tabContent"
              >
                {/* Default "ALL" Tab Content */}
                <TabPane tabId="ConfinedSpacePermitHealthDeclaration">
                  <ConfinedSpaceHealthDeclarationTextTab />
                </TabPane>
              </TabContent>
              <TabContent
                activeTab={verticalTab}
                className="text-muted mt-4 mt-md-0"
                id="v-pills-tabContent"
              >
                {/* Default "ALL" Tab Content */}
                <TabPane tabId="LiftingPermitHealthDeclaration">
                  <LiftingPermitHealthDeclarationTextTab />
                </TabPane>
              </TabContent>
              <TabContent
                activeTab={verticalTab}
                className="text-muted mt-4 mt-md-0"
                id="v-pills-tabContent"
              >
                {/* Default "ALL" Tab Content */}
                <TabPane tabId="WorkAtHeightHealthDeclarationPermit">
                  <WorkAtHeightPermitHealthDeclarationTextTab />
                </TabPane>
              </TabContent>
              <TabContent
                activeTab={verticalTab}
                className="text-muted mt-4 mt-md-0"
                id="v-pills-tabContent"
              >
                {/* Default "ALL" Tab Content */}
                <TabPane tabId="GeneralWorkHealthDeclarationPermit">
                  <GeneralWorkPermitHealthDeclarationTextTab />
                </TabPane>
              </TabContent>
              <TabContent
                activeTab={verticalTab}
                className="text-muted mt-4 mt-md-0"
                id="v-pills-tabContent"
              >
                {/* Default "ALL" Tab Content */}
                <TabPane tabId="HotWorkHealthDeclarationPermit">
                  <HotWorkPermitHealthDeclarationTextTab />
                </TabPane>
              </TabContent>
              <TabContent
                activeTab={verticalTab}
                className="text-muted mt-4 mt-md-0"
                id="v-pills-tabContent"
              >
                {/* Default "ALL" Tab Content */}
                <TabPane tabId="ExcavationHealthDeclarationPermit">
                  <ExcavationPermitHealthDeclarationTextTab />
                </TabPane>
              </TabContent>
              <TabContent
                activeTab={verticalTab}
                className="text-muted mt-4 mt-md-0"
                id="v-pills-tabContent"
              >
                {/* Default "ALL" Tab Content */}
                <TabPane tabId="PipeJackingHealthDeclarationPermit">
                  <PipeJackingPermitHealthDeclarationTextTab />
                </TabPane>
              </TabContent>
              <TabContent
                activeTab={verticalTab}
                className="text-muted mt-4 mt-md-0"
                id="v-pills-tabContent"
              >
                {/* Default "ALL" Tab Content */}
                <TabPane tabId="PilingHealthDeclarationPermit">
                  <PilingPermitHealthDeclarationTextTab />
                </TabPane>
              </TabContent>
              <TabContent
                activeTab={verticalTab}
                className="text-muted mt-4 mt-md-0"
                id="v-pills-tabContent"
              >
                {/* Default "ALL" Tab Content */}
                <TabPane tabId="ToolBoxMeetingHealthDeclaration">
                  <ToolBoxMeetingHealthDeclarationTextTab />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default HealthDeclarationTab;
